module.exports = __webpack_public_path__ + "partner_1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/partners/partner_1.jpg
// module id = 908
// module chunks = 0